import type { PromotedContestTab } from '~/services/marketing/promoted-contests.schema';

export const resolvePillSelection = ({
  tabs,
  selectedValue,
  knownEmptyValues,
}: {
  tabs: readonly PromotedContestTab[];
  selectedValue: string;
  knownEmptyValues: ReadonlySet<string>;
}): { visibleTabs: PromotedContestTab[]; activeTab: PromotedContestTab | null } => {
  const visibleTabs = tabs.filter((tab) => !knownEmptyValues.has(tab.value));
  const selectedIndex = tabs.findIndex((tab) => tab.value === selectedValue);
  const selectedTab = tabs[selectedIndex];

  if (selectedTab === undefined) {
    return { visibleTabs, activeTab: visibleTabs[0] ?? null };
  }

  const isVisibleAt = (index: number) => !knownEmptyValues.has(tabs[index].value);
  const indexes = tabs.map((_, index) => index);
  const nextIndex = indexes.find((index) => index >= selectedIndex && isVisibleAt(index));
  const previousIndex = indexes.findLast((index) => index < selectedIndex && isVisibleAt(index));
  const activeIndex = nextIndex ?? previousIndex;

  return { visibleTabs, activeTab: activeIndex === undefined ? null : tabs[activeIndex] };
};
